<div class="feed-entry-actions overflow-hidden">
    <div kui-action>
        @for (action of actions; track action) {
            <kui-icon [name]="action.icon" (click)="action.onClick()" size="sm"></kui-icon>
        }
    </div>
</div>
